import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaCookieBite } from 'react-icons/fa';
import './CookieConsent.css';

const STORAGE_KEY = 'proven-cookie-consent';

const CookieConsent = () => {
  const [ready, setReady] = useState(false);
  const [decided, setDecided] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let saved = null;
    try {
      saved = window.localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      /* storage blocked — treat as undecided */
    }
    setDecided(Boolean(saved));
    setOpen(!saved);
    setReady(true);
  }, []);

  const choose = (value) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, value);
    } catch (e) {
      /* ignore */
    }
    setDecided(true);
    setOpen(false);
  };

  if (!ready) return null;

  return (
    <>
      {/* Floating cookie button — reopens preferences after a choice is made. */}
      {decided && (
        <button
          type="button"
          className={`cookie-fab ${open ? 'hidden' : ''}`}
          aria-label="Cookie preferences"
          onClick={() => setOpen(true)}
        >
          <FaCookieBite />
        </button>
      )}

      {/* Consent banner (bottom-left). */}
      <div
        className={`cookie-banner ${open ? 'open' : ''}`}
        role="dialog"
        aria-label="Cookie consent"
        aria-hidden={!open}
      >
        <div className="cookie-banner-icon">
          <FaCookieBite />
        </div>
        <div className="cookie-banner-body">
          <h4 className="cookie-banner-title">We value your privacy</h4>
          <p className="cookie-banner-text">
            We use only essential cookies to keep the site secure and remember your preferences.
            No tracking or advertising cookies.{' '}
            <Link to="/cookie-policy" className="cookie-link" onClick={() => setOpen(false)}>
              Cookie Policy
            </Link>
          </p>
          <div className="cookie-actions">
            <button
              type="button"
              className="cookie-btn cookie-btn-accept"
              onClick={() => choose('acknowledged')}
            >
              Got it
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default CookieConsent;
